// extracted by mini-css-extract-plugin
export default {"title":"NoCard_title__ZWfmx","content":"NoCard_content__lV5C0","contentTitle":"NoCard_contentTitle__--9wF","button":"NoCard_button__VvKh4","link":"NoCard_link__kB7zu"};